module.exports = __webpack_public_path__ + "media/images/404_error-86f0638d.svg";